module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zigbee-hub"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/device/icon_zigbeeMini.png")
    }
  }), _vm._v(" "), _c('dl', [_c('dt', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.id))])]), _vm._v(" "), (_vm.buttonText) ? _c('button', {
    staticClass: "zigbee-hub-btn",
    on: {
      "touchstart": _vm.btnClick
    }
  }, [_vm._v(_vm._s(_vm.buttonText))]) : _vm._e(), _vm._v(" "), (_vm.desc) ? _c('b', [_vm._v(_vm._s(_vm.desc))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8bbc8cda"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/connect/zigbee/hub.vue
// module id = 916
// module chunks = 1